import { createStyles, makeStyles } from '@material-ui/styles';
import palette from '../../../../theme/palette';

const style = () =>
  createStyles({
    line: {
      display: 'flex',
      gap: '10px',
      alignItems: 'center',
      color: palette.common.black,
      fontWeight: 500
    },
    text: {
      margin: 0
    },
    blurText: {
      color: 'transparent',
      textShadow: '0 0 5px rgba(0,0,0,0.5)',
      userSelect: 'none'
    }
  });

const useStyle = makeStyles(style);
export default useStyle;
